import { render } from "./NavbarDesktop.vue?vue&type=template&id=6f6c5a39"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"

import "./NavbarDesktop.vue?vue&type=style&index=0&id=6f6c5a39&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__